import React, { useState, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import routes from "./routes/app-routes";
import { SideNavInnerToolbar as SideNavBarLayout } from "./layouts";
import { Footer } from "./components";
import { useAuth } from "./contexts/auth";
import ErrorBoundary from "./components/ErrorBoundary";
import RegisterDialogManager from "./components/RegisterDialogManager";

export default function Content() {
  const JDtech = "Powered by JD Tech";
  const [currRoutes, setCurrRoutes] = useState(routes);
  const { user } = useAuth();

  useEffect(() => {
    try {
      const newRoutes = routes.filter((r) => {
        return r.allowedUserTypes.some((role) => {
          return user.userRoles.includes(role);
        });
      });
      setCurrRoutes(newRoutes);
    } catch (e) {
      console.log("error setting routes");
    }
  }, [user]);

  // function checkRole(user){
  //   if (user.role == "Stylist"){
  //     return (stylistRoutes.map(({ path, component }) => (
  //       <Route
  //         exact
  //         key={path}
  //         path={path}
  //         component={component}
  //       />
  //     )));
  //   }
  //   if (user.role == "Admin"){
  //     return (AdminRoutes.map(({ path, component }) => (
  //       <Route
  //         exact
  //         key={path}
  //         path={path}
  //         component={component}
  //       />
  //     )));
  //   }
  //   if (user.role == "FrontDesk"){
  //     return (frontDeskRoutes.map(({ path, component }) => (
  //       <Route
  //         exact
  //         key={path}
  //         path={path}
  //         component={component}
  //       />
  //     )));
  //   }
  // }

  return (
    <SideNavBarLayout>
      <RegisterDialogManager />
      <ErrorBoundary>
        <Routes>
          {currRoutes.map(({ path, component }) => (
            <Route key={path} path={path} element={component} />
          ))}
        </Routes>
      </ErrorBoundary>
      <Footer>
        Copyright © 2011-{new Date().getFullYear()} {JDtech}
        <br />
        All trademarks or registered trademarks are property of their respective
        owners.
      </Footer>
    </SideNavBarLayout>
  );
}
